import React from 'react';
import "./Register.scss";

import {createUserWithEmailAndPassword, updateProfile} from 'firebase/auth';
import {auth,firestore} from '../../firebase/firebaseConfig'
import {doc,setDoc,getDoc} from 'firebase/firestore'
import { useDispatch } from 'react-redux';
import { setErrorMsg, setHasErrored } from '../../redux/errorReducer/errorSlice';
import { setIsLoading, setLoadingMsg } from '../../redux/loaderReducer/loaderSlice';
const Register = () => {
    const [userCredentials,setUserCredentials] = React.useState({
        displayName:"",
        email:"",
        password:"",
        confirmPass:""
    });
    const [formErrors,setFormErrors] = React.useState({})
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const dispatch = useDispatch();
    

    const handleChange = e => {
        setUserCredentials({...userCredentials,
            [e.target.name]: e.target.value
        })
    }
    const validation = (credentials) => {
        const errors = {};
        if(!credentials.displayName.length){
            errors.displayName = "Your name is required!"
        }
        else if (!credentials.email.length) {
            errors.email = "Your email is required!"
        }
        else if (!regex.test(credentials.email)) {
            errors.email = "Email format is not valid ! "
          }
        else if(!credentials.password.length) {
            errors.password = "Password is required!"
        }
       
        else if(credentials.password.length < 5){
            errors.password = "Password at least should be 5 characters"
        }
        else if(!credentials.confirmPass.length) {
            errors.confirmPass = "Password confirmation is required!"
        }
        else if (credentials.password !== credentials.confirmPass) {
            errors.confirmPass = "Passwords don't match"
        }
        return errors;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
       
        const validationResult = validation(userCredentials);
        // check if there are any errors
        if (Object.keys(validationResult).length > 0 ) {
          setFormErrors(validationResult);
          return; // stop the function if there are errors
        } 
       
        const {displayName,email,password} = userCredentials;
        //creating userin auth cloud
      try{  const {user} = await createUserWithEmailAndPassword(auth,email,password);
        dispatch(setIsLoading(true));
        dispatch(setLoadingMsg("Creating new profile..."))
        await updateProfile(user,{
            displayName,
          })
          const userRef =  doc(firestore,'users',`${user.uid}`)
          const userSnap = await getDoc(userRef)
          if(!userSnap.exists()){

            const {uid} = user;
            const date = new Date();
            const createdAt = date.toString();
            try {
                
              await setDoc(userRef,{
                uid,
                displayName,
                email,
                createdAt
              });
             
              dispatch(setIsLoading(false));
             dispatch(setLoadingMsg(null))
              
            } catch (error) {
             dispatch(setHasErrored(true));
             dispatch(setErrorMsg(error.message));
            }
          }}catch(error) {
            dispatch(setHasErrored(true));
             dispatch(setErrorMsg(error.message));
          }
          setUserCredentials({...userCredentials,displayName:"",email:"",password:"",confirmPass:""});
          
            setFormErrors({});
    }
   
  return (
    <div className="register-container">
       
        <div className="form-container">
        <div className="form-title">
                <h1>Register</h1>
            </div>
            <div className="formNimg">
            <form onSubmit={handleSubmit} className="form">
           
           <div className="form-group">
               <label htmlFor="displayName" className="form-label">Name:</label>
               <input onChange={handleChange} value={userCredentials.displayName} type="text" name="displayName" id="displayName" className="form-control" />
               <p className={`${formErrors.displayName ? 'form-input-error':'hide'}`}>{formErrors.displayName}</p>
           </div>
           <div className="form-group">
               <label htmlFor="email" className="form-label">Email:</label>
               <input onChange={handleChange} value={userCredentials.email} type="email" name="email" id="email" className="form-control" />
               <p className={`${formErrors.email ? 'form-input-error':'hide'}`}>{formErrors.email}</p>
           </div>
           <div className="form-group">
               <label htmlFor="password" className="form-label">Password:</label>
               <input onChange={handleChange} value={userCredentials.password} type="password" name="password" id="password" className="form-control" />
               <p className={`${formErrors.password? 'form-input-error':'hide'}`}>{formErrors.password}</p>
           </div>
           <div className="form-group">
               <label htmlFor="confirmPass" className="form-label">Confirm Password:</label>
               <input onChange={handleChange} value={userCredentials.confirmPass} type="password" name="confirmPass" id="confirmPass" className="form-control" />
               <p className={`${formErrors.confirmPass ? 'form-input-error':'hide'}`}>{formErrors.confirmPass}</p>
           </div>
           <div className="form-btn-container">
            <button type='submit' className="form-btn" >Register</button>
           </div>
       </form>
       <div className="img-container">
       <object className='form-svg' aria-label="svg animtaed picture" data="./brain.svg" type="image/svg+xml"></object>
       <p>Smart Brain</p>
       </div>
            </div>

        </div>
    </div>
  )
}

export default Register